import { render, staticRenderFns } from "./DocPerson.vue?vue&type=template&id=673a1cdd&scoped=true&"
import script from "./DocPerson.vue?vue&type=script&lang=js&"
export * from "./DocPerson.vue?vue&type=script&lang=js&"
import style0 from "./DocPerson.vue?vue&type=style&index=0&id=673a1cdd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673a1cdd",
  null
  
)

export default component.exports